import * as React from 'react';

const ScanCheckFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="scan-check-fill_svg__a"
                d="M0 0h20v20H0V0zm18 14v4h-4v1h5v-5h-1zM1 14v5h5v-1H2v-4H1zM14 1v1h4v4h1V1h-5zM1 1h5v1H2v4H1V1zm12.297 6.511l.707.707L9 13l-2.967-2.78.707-.708L9 11.793l4.297-4.282z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(2 2)">
            <mask id="scan-check-fill_svg__b" fill="#fff">
                <use xlinkHref="#scan-check-fill_svg__a" />
            </mask>
            <use fill="#45494E" xlinkHref="#scan-check-fill_svg__a" />
            <g mask="url(#scan-check-fill_svg__b)">
                <path fill="#000" d="M-2-2h24v24H-2z" />
            </g>
        </g>
    </svg>
);

ScanCheckFillSvg.displayName = 'ScanCheckFillSvg';
export default ScanCheckFillSvg;
